<ion-card class="notification">
  <ion-card-content class="notification__content">
    <span class="white mapfre-fs-xs df ai-c">{{ text | translate }}</span>
    <ion-icon color="white" name="checkmark-outline"></ion-icon>
  </ion-card-content>
</ion-card>
